export default {
  allLocations (state, getters, rootState) {
    return state.allLocations
  }
}



// WEBPACK FOOTER //
// ./src/modules/location/store/getters.js